import { render, staticRenderFns } from "./CreateMessageHeader.vue?vue&type=template&id=95d71586&scoped=true"
import script from "./CreateMessageHeader.vue?vue&type=script&lang=js"
export * from "./CreateMessageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d71586",
  null
  
)

export default component.exports